import React from 'react';

interface StarProps {
  fill?: string;
  className?: string;
}

export const Star = ({ fill = '#FFB33E', className = '' }: StarProps) => (
  <svg className={className} width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8 4.65c0 .136-.1.265-.2.363L9.808 7.69l.661 3.78c.008.054.008.099.008.152 0 .197-.092.378-.316.378a.633.633 0 01-.307-.09L6.4 10.124l-3.454 1.784c-.1.053-.2.091-.308.091-.223 0-.323-.181-.323-.378 0-.053.008-.098.016-.151l.661-3.781-2.8-2.677C.1 4.915 0 4.786 0 4.65c0-.227.238-.317.43-.348l3.862-.552L6.023.31c.07-.144.2-.31.377-.31s.308.166.377.31l1.73 3.44 3.862.552c.185.03.431.121.431.348z"
      fill={fill}
    />
  </svg>
);
